import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { linkTo } from 'env/utils/strings';
import withCustomComponent from 'ui/components/withCustomComponent';

export const EventsPageZeroCase = withCustomComponent('EventsPageZeroCase')(
  withRouter(({ router, componentName, pastEvents }) => {
    const { t } = useTranslation();
    return (
      <div data-component-name={componentName} className="text-center pt-32">
        <i className="icon-date-availability fs-64 text-gray-600"></i>
        <h3 className="mt-12 mb-24">{t('There are no events to display')}</h3>
        {!pastEvents && (
          <Link
            href={linkTo(router, { page: 1, pastEvents: true })}
            className="btn"
          >
            {t('Check what you missed')}
          </Link>
        )}
      </div>
    );
  })
);
